<template>
    <div>
        <div>
            {{ skuName || '--' }}
            <span style="font-size:12px;color:#EB2F3C;">
                <i
                    class="mtdicon mtdicon-warning-circle"
                    style="font-size:12px"
                ></i>
                标题预览效果
            </span>
        </div>
        <div class="el-form-item__description is-bottom">
            「营销词」+「商品名称」系统自动拼接
        </div>
    </div>
</template>

<script>
export default {
    name: 'SKUName',
    props: {
        skuName: {
            type: String,
            default: '',
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
</style>
